import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { memo } from "react";
import { MonthView } from "react-calendar";
import { addMonths, eachMonthOfInterval, max, min, subMonths } from "date-fns";
import isEqual from "lodash/isEqual";
import omit from "lodash/omit";
import { useCalendar } from "../../../../services/hooks/index.js";
import { Tooltip } from "../../../../Tooltip/index.js";
import { DropdownButton } from "../../../../DropdownButton/index.js";
import { MenuItem } from "../../../../MenuItem/index.js";
import { Typography } from "../../../../Typography/index.js";
import { Link } from "../../../../Link/index.js";
import { Box } from "../../../../Box/index.js";
import { Icon } from "../../../../Icon/index.js";
import { useIsDesktop } from "../../../../hooks/index.js";
import Month_styles from "./Month.styles.js";
const Month = /*#__PURE__*/ memo((t0)=>{
    const $ = c(68);
    const { year, month, value, onChange, minDate, maxDate, createTooltipText, shouldDisableDate, onDelete, holidays, regionalHolidays, hoverDate, setHoverDate, range, readonly, disabled, onRangeClick, clearable, onClear, deletedRanges } = t0;
    const { classes } = Month_styles();
    const calendar = useCalendar();
    const isDesktop = useIsDesktop();
    let activeStartDate;
    let t1;
    if ($[0] !== month || $[1] !== year) {
        activeStartDate = new Date(year, month);
        const monthName = activeStartDate.toLocaleString("ru-RU", {
            month: "long"
        });
        t1 = monthName.replace(monthName[0], monthName[0].toUpperCase());
        $[0] = month;
        $[1] = year;
        $[2] = activeStartDate;
        $[3] = t1;
    } else {
        activeStartDate = $[2];
        t1 = $[3];
    }
    const formattedMonthName = t1;
    let t2;
    if ($[4] !== onClear) {
        t2 = ()=>{
            if (onClear) onClear();
        };
        $[4] = onClear;
        $[5] = t2;
    } else t2 = $[5];
    const handleClear = t2;
    let t3;
    if ($[6] !== calendar || $[7] !== createTooltipText || $[8] !== hoverDate || $[9] !== isDesktop || $[10] !== onDelete || $[11] !== onRangeClick || $[12] !== range[0] || $[13] !== setHoverDate || $[14] !== value) {
        t3 = (t4)=>{
            const { date } = t4;
            const clickedRange = null == value ? void 0 : value.find((selectedRange)=>date >= selectedRange[0] && date <= selectedRange[1]);
            const handleRangeClick = ()=>{
                if (onRangeClick && clickedRange) onRangeClick(clickedRange);
            };
            const onDateClick = ()=>{
                if (!range[0]) setHoverDate(date);
            };
            const onMouseEnter = ()=>{
                if (range[0]) setHoverDate(date);
            };
            const onMouseLeave = ()=>{
                if (date && !range[0] && hoverDate && calendar.isSameDay(date, hoverDate)) setHoverDate(null);
            };
            const tooltipText = createTooltipText ? createTooltipText(date) : "";
            if (!!clickedRange && onRangeClick) return /*#__PURE__*/ jsx(Tooltip, {
                placement: "top",
                title: tooltipText,
                disabled: !tooltipText,
                children: /*#__PURE__*/ jsx("span", {
                    children: /*#__PURE__*/ jsx(DropdownButton, {
                        variant: "quaternary",
                        verticalPosition: "bottom",
                        horizontalPosition: "right",
                        button: (t5)=>{
                            const { onClick } = t5;
                            return /*#__PURE__*/ jsx("div", {
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: 32,
                                    height: 32
                                },
                                onClick: (e)=>{
                                    onClick(e);
                                    handleRangeClick();
                                },
                                onMouseEnter: onMouseEnter,
                                onMouseLeave: onMouseLeave
                            });
                        },
                        menuItems: [
                            /*#__PURE__*/ jsx(MenuItem, {
                                onClick: ()=>onDelete(date),
                                children: isDesktop ? "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D" : /*#__PURE__*/ jsxs(Box, {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8",
                                    children: [
                                        /*#__PURE__*/ jsx(Icon, {
                                            name: "delete_outline",
                                            size: "16",
                                            color: "text.light.primary"
                                        }),
                                        /*#__PURE__*/ jsx(Box, {
                                            children: "Удалить диапазон"
                                        })
                                    ]
                                })
                            }, "1")
                        ]
                    })
                })
            });
            return /*#__PURE__*/ jsx(Tooltip, {
                placement: "top",
                title: tooltipText,
                disabled: !tooltipText,
                children: /*#__PURE__*/ jsx("div", {
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: 32,
                        height: 32
                    },
                    onClick: onDateClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave
                })
            });
        };
        $[6] = calendar;
        $[7] = createTooltipText;
        $[8] = hoverDate;
        $[9] = isDesktop;
        $[10] = onDelete;
        $[11] = onRangeClick;
        $[12] = range[0];
        $[13] = setHoverDate;
        $[14] = value;
        $[15] = t3;
    } else t3 = $[15];
    const createTileContent = t3;
    let t4;
    if ($[16] !== calendar || $[17] !== classes.day || $[18] !== classes.deletedRangeDay || $[19] !== classes.deletedRangeDayEnd || $[20] !== classes.deletedRangeDayStart || $[21] !== classes.holiday || $[22] !== classes.rangeEnd || $[23] !== classes.rangeStart || $[24] !== classes.readOnly || $[25] !== classes.regionalHoliday || $[26] !== classes.selectedRangeDay || $[27] !== classes.selectedRangeDayEnd || $[28] !== classes.selectedRangeDayStart || $[29] !== deletedRanges || $[30] !== holidays || $[31] !== hoverDate || $[32] !== range[0] || $[33] !== readonly || $[34] !== regionalHolidays || $[35] !== shouldDisableDate || $[36] !== value) {
        t4 = (t5)=>{
            const { date: date_0 } = t5;
            let classname = `${classes.day}`;
            const isInRange = !!date_0 && !!range[0] && !!hoverDate && (date_0 >= range[0] && date_0 <= hoverDate || date_0 >= hoverDate && date_0 <= range[0]);
            const isRangeStart = isInRange && date_0 && range[0] && hoverDate && (calendar.isSameDay(date_0, range[0]) && hoverDate >= range[0] || calendar.isSameDay(date_0, hoverDate) && hoverDate < range[0]);
            if (isInRange) classname = `${classname} ${classes.selectedRangeDay}`;
            if (isRangeStart) classname = `${classname} ${classes.rangeStart}`;
            if (!(shouldDisableDate ? shouldDisableDate(date_0, range[0]) : false)) {
                const isRangeEnd = isInRange && date_0 && range[0] && hoverDate && (calendar.isSameDay(date_0, hoverDate) && range[0] <= hoverDate || calendar.isSameDay(date_0, range[0]) && range[0] > hoverDate);
                if (isRangeEnd) classname = `${classname} ${classes.rangeEnd}`;
                null == value || value.forEach((selectedRange_0)=>{
                    if (!isInRange && date_0 >= selectedRange_0[0] && date_0 <= selectedRange_0[1]) {
                        classname = `${classname} ${classes.selectedRangeDay}`;
                        if (calendar.isSameDay(date_0, selectedRange_0[0])) classname = `${classname} ${classes.selectedRangeDayStart}`;
                        if (calendar.isSameDay(date_0, selectedRange_0[1])) classname = `${classname} ${classes.selectedRangeDayEnd}`;
                    }
                });
            }
            null == holidays || holidays.forEach((holiday)=>{
                if (calendar.isSameDay(date_0, holiday)) classname = `${classname} ${classes.holiday}`;
            });
            null == regionalHolidays || regionalHolidays.forEach((regionalHoliday)=>{
                if (calendar.isSameDay(date_0, regionalHoliday)) classname = `${classname} ${classes.regionalHoliday}`;
            });
            null == deletedRanges || deletedRanges.forEach((deleted)=>{
                if (date_0 >= deleted[0] && date_0 <= deleted[1] && !range[0]) {
                    classname = `${classname} ${classes.deletedRangeDay}`;
                    if (calendar.isSameDay(date_0, deleted[0]) && !range[0]) classname = `${classname} ${classes.deletedRangeDayStart}`;
                    if (calendar.isSameDay(date_0, deleted[1]) && !range[0]) classname = `${classname} ${classes.deletedRangeDayEnd}`;
                }
            });
            if (readonly) classname = `${classname} ${classes.readOnly}`;
            return classname;
        };
        $[16] = calendar;
        $[17] = classes.day;
        $[18] = classes.deletedRangeDay;
        $[19] = classes.deletedRangeDayEnd;
        $[20] = classes.deletedRangeDayStart;
        $[21] = classes.holiday;
        $[22] = classes.rangeEnd;
        $[23] = classes.rangeStart;
        $[24] = classes.readOnly;
        $[25] = classes.regionalHoliday;
        $[26] = classes.selectedRangeDay;
        $[27] = classes.selectedRangeDayEnd;
        $[28] = classes.selectedRangeDayStart;
        $[29] = deletedRanges;
        $[30] = holidays;
        $[31] = hoverDate;
        $[32] = range[0];
        $[33] = readonly;
        $[34] = regionalHolidays;
        $[35] = shouldDisableDate;
        $[36] = value;
        $[37] = t4;
    } else t4 = $[37];
    const createTileClassName = t4;
    let t5;
    if ($[38] !== formattedMonthName) {
        t5 = /*#__PURE__*/ jsx(Typography, {
            variant: "subtitle2",
            children: formattedMonthName
        });
        $[38] = formattedMonthName;
        $[39] = t5;
    } else t5 = $[39];
    let t6;
    if ($[40] !== clearable || $[41] !== handleClear) {
        t6 = clearable && /*#__PURE__*/ jsx(Link, {
            stroke: false,
            onClick: handleClear,
            children: "Сбросить"
        });
        $[40] = clearable;
        $[41] = handleClear;
        $[42] = t6;
    } else t6 = $[42];
    let t7;
    if ($[43] !== classes.monthName || $[44] !== t5 || $[45] !== t6) {
        t7 = /*#__PURE__*/ jsxs("div", {
            className: classes.monthName,
            children: [
                t5,
                t6
            ]
        });
        $[43] = classes.monthName;
        $[44] = t5;
        $[45] = t6;
        $[46] = t7;
    } else t7 = $[46];
    let t8;
    if ($[47] !== calendar || $[48] !== disabled || $[49] !== range[0] || $[50] !== shouldDisableDate || $[51] !== value) {
        t8 = (t9)=>{
            const { date: date_1 } = t9;
            if (disabled) return value ? !calendar.isWithinIntervals(date_1, value) : true;
            return shouldDisableDate ? shouldDisableDate(date_1, range[0]) : false;
        };
        $[47] = calendar;
        $[48] = disabled;
        $[49] = range[0];
        $[50] = shouldDisableDate;
        $[51] = value;
        $[52] = t8;
    } else t8 = $[52];
    let t9;
    if ($[53] !== activeStartDate || $[54] !== createTileClassName || $[55] !== createTileContent || $[56] !== maxDate || $[57] !== minDate || $[58] !== onChange || $[59] !== range || $[60] !== t8) {
        t9 = /*#__PURE__*/ jsx(MonthView, {
            showFixedNumberOfWeeks: true,
            showNeighboringMonth: true,
            valueType: "day",
            activeStartDate: activeStartDate,
            value: range,
            locale: "ru",
            onClick: onChange,
            minDate: minDate,
            maxDate: maxDate,
            tileClassName: createTileClassName,
            tileContent: createTileContent,
            tileDisabled: t8
        });
        $[53] = activeStartDate;
        $[54] = createTileClassName;
        $[55] = createTileContent;
        $[56] = maxDate;
        $[57] = minDate;
        $[58] = onChange;
        $[59] = range;
        $[60] = t8;
        $[61] = t9;
    } else t9 = $[61];
    let t10;
    if ($[62] !== classes.root || $[63] !== t9) {
        t10 = /*#__PURE__*/ jsx("div", {
            className: classes.root,
            children: t9
        });
        $[62] = classes.root;
        $[63] = t9;
        $[64] = t10;
    } else t10 = $[64];
    let t11;
    if ($[65] !== t10 || $[66] !== t7) {
        t11 = /*#__PURE__*/ jsxs("div", {
            children: [
                t7,
                t10
            ]
        });
        $[65] = t10;
        $[66] = t7;
        $[67] = t11;
    } else t11 = $[67];
    return t11;
}, (prev, next)=>isEqual(omit(prev, 'hoverDate', 'range'), omit(next, 'hoverDate', 'range')) && !(!prev.hoverDate || !prev.range[0] || eachMonthOfInterval({
        start: subMonths(min([
            prev.hoverDate,
            next.hoverDate,
            prev.range[0],
            next.range[0]
        ].filter((date)=>!!date)), 1),
        end: addMonths(max([
            prev.hoverDate,
            next.hoverDate,
            prev.range[0],
            next.range[0]
        ].filter((date)=>!!date)), 1)
    }).map((date)=>date.getMonth()).includes(next.month)));
export { Month };
